import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaViewer from './VaViewer.vue'

export const VaViewer = withConfigTransport(_VaViewer)
